export const acceptUploadFileTypes = [
  '.png',
  '.jpeg',
  '.jpg',
  '.webp',
  '.gif',
  '.bmp',
  '.tif',
  '.tiff',
  '.pdf',
  '.xls',
  '.xlsx',
  '.doc',
  '.docx',
  '.csv',
  '.txt',
  '.rtf',
].join(', ');
